import React from 'react';
import { XCircle } from 'lucide-react';
export function FailedSolutions() {
  const failures = [{
    title: 'Dietas extremas',
    desc: 'Las dietas de 1,200 calorías elevan tu cortisol y le dicen a tu cuerpo: "¡Peligro! Guarda grasa en el abdomen".'
  }, {
    title: 'Exceso de ejercicio',
    desc: 'El cardio intenso de impacto inflama tus articulaciones y dispara el estrés oxidativo.'
  }, {
    title: 'Falsos saludables',
    desc: 'Los productos "Light" y edulcorantes destruyen tu flora intestinal, causando gases y distensión abdominal.'
  }, {
    title: 'Comida fría',
    desc: 'Comer solo ensaladas frías puede estar ralentizando tu digestión si no incluyes las enzimas correctas.'
  }];
  return <section className="bg-sage-dark text-white py-16 md:py-24 px-6" data-id="element-13">
      <div className="text-container" data-id="element-14">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-white" data-id="element-15">
          Por qué lo que has intentado NO funciona
        </h2>
        <p className="text-center text-sage-light mb-12 text-lg" data-id="element-16">
          Estás luchando contra tu biología, no contra tu fuerza de voluntad.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-17">
          {failures.map((item, index) => <div key={index} className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 flex items-start gap-4 border border-white/20" data-id="element-18">
              <XCircle className="w-8 h-8 text-gold flex-shrink-0 mt-1" data-id="element-19" />
              <div data-id="element-20">
                <p className="text-lg leading-relaxed" data-id="element-21">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}